import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconReferralSource from 'components/icons/IconReferralSource';

const styles = () => ({
  root: {
    height: 330,
  },
  iconReferralSource: {
    width: 105,
    height: 105,
  },
  typographyBody: {
    textAlign: 'center',
    margin: '16px 16px 0 16px',
  },
});

const VendorsTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={0}
  >
    <Grid item>
      <IconReferralSource className={classes.iconReferralSource} />
    </Grid>
    <Grid item>
      <Typography className={classes.typographyBody} variant="subheading" color="secondary">
        Unfortunately, there are no such vendors
      </Typography>
    </Grid>
  </Grid>
);

VendorsTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconReferralSource: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(VendorsTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/VendorsTable/VendorsTableEmpty.js